module.exports = __webpack_public_path__ + "static/media/proj12_img1.0d256e1b.jpg";